import React, { useState, useContext, useEffect } from "react";
import { auth, GoogleProvider } from "../Config/firebase";
const AuthContext = React.createContext();

export const useAuth = () => {
  return useContext(AuthContext);
};

export const AuthProvider = ({ children }) => {
  const [currentUser, setCurrentUser] = useState(null);
  const [loadding, setLoading] = useState(true);

  const signUp = (email, password) => {
    return auth.createUserWithEmailAndPassword(email, password);
  };
  const signUpWithGoogle = () => {
    return auth.signInWithPopup(GoogleProvider);
  };
  const login = (email, password) => {
    return auth.signInWithEmailAndPassword(email, password);
  };
  const loginWithGoogle = () => {
    return auth.signInWithPopup(GoogleProvider);
  };

  const logout = () => {
    return auth.signOut();
  };
  useEffect(() => {
    auth.onAuthStateChanged(async (user) => {
      setCurrentUser(user);
      setLoading(false);
      if (user) {
        user.getIdToken().then((token) => {
          localStorage.setItem("refresh_Token", user.refreshToken);
          localStorage.setItem("id_token", token);
        });
      } else {
        localStorage.setItem("refresh_Token", null);
        localStorage.setItem("id_token", null);
        localStorage.setItem("user", null);
      }
    });
  }, []);

  const value = {
    currentUser,
    signUp,
    login,
    logout,
    signUpWithGoogle,
    loginWithGoogle,
  };

  return (
    <AuthContext.Provider value={value}>
      {!loadding && children}
    </AuthContext.Provider>
  );
};
